@layer refine.base {
  :host {
    display: block;
    margin: var(--_separator-margin, var(--size-1)) 0;
    border-top: var(--border) solid var(--color-contrast-200);
  }
}
